import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ICollection } from '../collection-schema';

export async function listPublicCollectionChildrenApi(id: number) {
  return getRequest<IAPI<ICollection[]>>({
    path: `/collections/${id}/children`,
  });
}
